import React from 'react';
import Home from './component/Home';
import Productdetail from './page/productdetail'
import Login from './component/Login';
import { Basket } from './component/Basket';
import Categories from './component/Categories1';
import Checkout from './component/Checkout'
import { Route,Router,Routes } from 'react-router-dom';
import './App.css';
import {Order} from './component/Order'
import Homepage from './page/Homepage';
import { Searchresult } from './component/Searchresult';
import Wishlist from './component/Wishlist';
import Allproduct from './component/Allproduct';





function App() {
  

  return (
    <div className="App">
<Routes>
  {/* <Route  element={<Home/>}>    </Route> */}
  <Route index element={<Homepage/>}></Route>
  <Route  path='categories/:categoriesid' element={<Categories/>}/>
  <Route path='Product/:Productid' element={<Productdetail/>}/>  
  <Route path='basket' element={<Basket/>}> </Route>  
  <Route path='checkout' element={<Checkout/>}></Route>
  <Route path='Searchresult' element={<Searchresult/>}/>
  <Route path='Order' element={<Order/>} />
  <Route path='Login' element={<Login/>}></Route>
  <Route path='Wishlist' element={<Wishlist/>}></Route>
  <Route path='Allproduct' element={<Allproduct/>}></Route>   
 
</Routes>
    </div>
  );
}

export default App;
